import type { UseFormWatch } from "react-hook-form"
import { useFormContext, useWatch } from "react-hook-form"
import type { SwapFlowFormValues } from "../types"

export function useCanLoadQuote(watch?: UseFormWatch<SwapFlowFormValues>) {
  const context = useFormContext<SwapFlowFormValues>()
  const [fromQuantity, toQuantity, toCurrency, transactionMode] = watch
    ? watch(["fromQuantity", "toQuantity", "toCurrency", "transactionMode"])
    : // biome-ignore lint/correctness/useHookAtTopLevel: Intentional for now
      useWatch({
        control: context.control,
        name: ["fromQuantity", "toQuantity", "toCurrency", "transactionMode"],
      })

  const fromQuantityValid =
    !Number.isNaN(fromQuantity) &&
    fromQuantity !== undefined &&
    fromQuantity !== 0

  const toQuantityValid =
    !Number.isNaN(toQuantity) && toQuantity !== undefined && toQuantity !== 0

  // In buy mode, check toQuantity; in sell mode (or undefined for backwards compatibility), check fromQuantity
  const quantityValid =
    transactionMode === "buy" ? toQuantityValid : fromQuantityValid

  return Boolean(toCurrency && quantityValid)
}
